<template>
  <div>
    <el-form
      v-if="isItInvalid == false && isSuccess == false"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm container"
    >
      <p
        style="text-align:center;font-size: 16px;padding:10px 0;font-weight: 600;"
      >
        完善信息
      </p>
      <div class="info-head">
        <div style="font-size:16px;padding-bottom:10px;">
          <i class="el-icon-time"></i><span> {{ formatTime }}</span>
        </div>
        <div style="font-weight:bold;font-size:14px">
          尊敬的客户，您好！请按如下提示完善信息。
        </div>
      </div>
      <div style="padding:0 20px">
        <p class="step-header">基础信息</p>
        <el-form-item label="单位名称" prop="workUnitName" class="form-item">
          <el-input
            v-model="ruleForm.workUnitName"
            placeholder="请输入客户单位全称"
          ></el-input>
        </el-form-item>
        <el-form-item label="课题组" prop="researchGroupName" class="form-item">
          <el-input
            v-model="ruleForm.researchGroupName"
            placeholder="请填写课题组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoiceTitle" class="form-item">
          <el-input
            v-model="ruleForm.invoiceTitle"
            placeholder="请输入发票抬头"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="收寄地址"
          prop="address"
          class="form-item"
          style="width:100%"
        >
          <BaseRegion
            :value="address"
            @change="handleAddressChange"
          ></BaseRegion>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile" class="form-item">
          <el-input
            v-model="ruleForm.mobile"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" class="form-item">
          <el-input
            v-model="ruleForm.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </div>
      <div class="submit-btn" @click="submitForm('ruleForm')">提交</div>
    </el-form>
    <div v-if="isItInvalid == true && isSuccess == false" class="link_failure">
      <img src="@/assets/images/failedLink.png" class="img-width" />
      <p style="padding-top: 20px;">
        对不起，该链接已失效，
      </p>
      <p style="padding-top: 20px;">
        可以联系销售人员反馈信息。
      </p>
    </div>
    <div class="link_failure" v-if="isItInvalid == false && isSuccess == true">
      <img src="@/assets/images/icon_success.png" />
      <h2>提交成功</h2>
    </div>
  </div>
</template>
<script>
import { HotTable } from "@handsontable-pro/vue";
import "handsontable-pro/dist/handsontable.full.css";
import {
  temporaryCustomerUsersHashKey,
  temporaryCustomerUsersSave
} from "@/services/api.index";
import BaseRegion from "@/components/BaseRegion";
import _ from "lodash";
export default {
  components: {
    HotTable,
    BaseRegion
  },
  data() {
    return {
      formatTime: "",
      isSuccess: null,
      isItInvalid: null,
      returnData: {},
      ruleForm: {
        detail: "",
        workUnitName: "",
        researchGroupName: "",
        invoiceTitle: "",
        mobile: "",
        email: "",
        address: {
          city: "",
          cityCode: "",
          county: null,
          countyCode: null,
          detail: "",
          province: "",
          provinceCode: ""
        }
      },
      address: {
        city: "",
        cityCode: "",
        county: null,
        countyCode: null,
        detail: "",
        province: "",
        provinceCode: ""
      },
      rules: {
        workUnitName: [
          { required: true, message: "必填项不可为空", trigger: "change" }
        ],
        researchGroupName: [
          { required: true, message: "必填项不可为空", trigger: "change" }
        ],
        invoiceTitle: [
          { required: true, message: "必填项不可为空", trigger: "change" }
        ],
        mobile: [
          { required: true, message: "必填项不可为空", trigger: "change" }
        ],
        email: [
          { required: true, message: "必填项不可为空", trigger: "change" }
        ],
        address: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const {
                cityCode,
                provinceCode,
                countyCode,
                detail
              } = this.ruleForm.address;
              if (!provinceCode) {
                return callback(new Error("请选择省！"));
              }
              if (!cityCode) {
                return callback(new Error("请选择城市！"));
              }
              if (!countyCode) {
                return callback(new Error("请选择区！"));
              }
              if (!detail) {
                callback(new Error("请填写详细地址！"));
                return;
              }
              if (_.trim(detail).length > 100) {
                callback(new Error("详细地址不能超过100字！"));
                return;
              }
              callback();
            }
          }
        ]
      }
    };
  },
  async created() {
    const { hashKey } = this.$route.query;
    const { data } = await temporaryCustomerUsersHashKey(hashKey);
    this.returnData = data;
    if (data.errorMsg) {
      this.isItInvalid = true;
    } else {
      this.isItInvalid = false;
      this.handleTime(data.timeDifference);
    }
    this.isSuccess = false;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            ...this.ruleForm,
            submitUserType: "CUSTOMER",
            id: this.returnData.id,
            hashKey: this.$route.query.hashKey
          };
          await temporaryCustomerUsersSave(params);
          this.isSuccess = true;
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleAddressChange(data) {
      this.ruleForm.address.province = data.province;
      this.ruleForm.address.provinceCode = data.provinceCode;
      this.ruleForm.address.city = data.city;
      this.ruleForm.address.cityCode = data.cityCode;
      this.ruleForm.address.county = data.county;
      this.ruleForm.address.countyCode = data.countyCode;
      this.ruleForm.address.detail = data.detail;
    },
    handleTime(data) {
      const time = _.map(_.split(data, ":"), _.parseInt);
      let distance =
        time[0] * 60 * 60 * 1000 + time[1] * 60 * 1000 + time[2] * 1000;
      const countdownInterval = setInterval(() => {
        distance = distance - 1000;
        if (distance <= 0) {
          clearInterval(countdownInterval);
          this.isItInvalid = true;
          this.isSuccess = false;
        } else {
          const seconds = Math.floor((distance / 1000) % 60);
          const minutes = Math.floor((distance / 1000 / 60) % 60);
          const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
          this.formatTime = `${this.baseMethods.pad2(
            hours
          )}:${this.baseMethods.pad2(minutes)}:${this.baseMethods.pad2(
            seconds
          )}`;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scpoed>
@media screen and (max-width: 768px) {
  .demo-ruleForm {
    width: 100%;
    height: 100%;
  }

  .el-form-item__label {
    color: #a8aeb2 !important;
    //padding: 0 10px;
  }
  .img-width {
    width: 50%;
  }
}
@media screen and (min-width: 768px) {
  .img-width {
    width: 10%;
  }
}
.link_failure {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  color: #303f45;
  font-size: 14px;
}
.info-head {
  background-image: url("~@/assets/images/improveInformationHead.png");
  background-size: cover;
  padding: 0 15px;
  margin-bottom: 8px;
  text-align: center;
  color: #ffffff;
  padding: 25px 0;
}
.step-header {
  font-size: 16px;
  color: #1d2c36;
  margin-left: -10px;
  border-left: 5px solid #014492;
  padding-left: 10px;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  //border: none !important;
  border-bottom: 1px solid #f5f5f5;
}
.el-input__inner {
  border: none;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.confirm-font {
  display: flex;
  justify-content: space-between;
}
.submit-btn {
  display: flex;
  justify-content: center;
  width: 100%;
  color: #fff;
  //padding: 20px;
  margin-top: 50px;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(135deg, #014492 0%, #6ec8e2 100%);
}
</style>



// WEBPACK FOOTER //
// src/views/APPLink/ImproveInformation.vue